@file:Suppress("UNCHECKED_CAST_TO_EXTERNAL_INTERFACE")

package org.example.project.registrierung

import androidx.compose.runtime.*
import kotlinx.browser.window
import org.example.project.dashboard.DashboardTheme
import org.example.project.login.UnifiedAccessStyles
import org.example.project.settings.LogoSettings
import org.example.project.utils.All
import org.example.project.utils.DashboardVerlaufHintergrund
import org.example.project.utils.FormStyles
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.events.Event

private const val NET_VIEW_NONE = "none"
private const val NET_VIEW_LOGIN = "login"
private const val NET_VIEW_REGISTER = "register"

@Composable
fun DesktopRegistrierungScreen(
    onSubmit: () -> Unit,
    externalScreen: String? = null
) {
    Style(NetzwerkLoginStyles)
    Style(UnifiedAccessStyles)
    Style(FormStyles)
    DashboardVerlaufHintergrund()

    var registeredCompanies by remember { mutableStateOf<List<All>>(emptyList()) }

    LaunchedEffect(Unit) {
        registeredCompanies = DesktopRegistrierungApi.registeredCompanies()
    }


    var activeView by remember("desktop-registration-string-view") { mutableStateOf(NET_VIEW_LOGIN) }
    var isMobile by remember { mutableStateOf(window.innerWidth <= 768) }
    var mobileMenuOpen by remember { mutableStateOf(false) }

    DisposableEffect(Unit) {
        val resizeListener: (Event) -> Unit = {
            isMobile = window.innerWidth <= 768
            if (!isMobile) mobileMenuOpen = false
        }
        window.addEventListener("resize", resizeListener)
        onDispose { window.removeEventListener("resize", resizeListener) }
    }

    fun activateExternalScreen(screen: String?) {
        activeView = when (screen) {
            "login" -> NET_VIEW_LOGIN
            "register" -> NET_VIEW_REGISTER
            else -> NET_VIEW_LOGIN
        }
    }

    LaunchedEffect(externalScreen) {
        activateExternalScreen(externalScreen)
    }


    fun updateNetworkTilt(eventTarget: dynamic, clientX: Double, clientY: Double) {
        val rect = eventTarget.getBoundingClientRect()
        val x = (clientX - rect.left as Double) / (rect.width as Double) - 0.5
        val y = (clientY - rect.top as Double) / (rect.height as Double) - 0.5
        eventTarget.style.setProperty("--ry", "${x * 13}deg")
        eventTarget.style.setProperty("--rx", "${y * -13}deg")
    }

    fun resetNetworkTilt(eventTarget: dynamic) {
        eventTarget.style.setProperty("--ry", "0deg")
        eventTarget.style.setProperty("--rx", "0deg")
    }

    if (false) Header({ classes(NetzwerkLoginStyles.topBar) }) {
        Div({ classes(NetzwerkLoginStyles.headerContent) }) {
            if (false) {
                Div({ classes(NetzwerkLoginStyles.mobileNavigation) }) {
                    Button(attrs = {
                        classes(NetzwerkLoginStyles.mobileMenuButton)
                        attr("aria-label", "Navigation öffnen")
                        attr("aria-expanded", mobileMenuOpen.toString())
                        onClick { mobileMenuOpen = !mobileMenuOpen }
                    }) { Text("☰") }
                    if (mobileMenuOpen) {
                        Div({ classes(NetzwerkLoginStyles.mobileMenuDropdown) }) {
                            Div({
                                classes(NetzwerkLoginStyles.mobileMenuEntry)
                                if (activeView == NET_VIEW_LOGIN) classes(NetzwerkLoginStyles.mobileMenuEntryActive)
                                onClick {
                                    activeView = NET_VIEW_LOGIN
                                    mobileMenuOpen = false
                                }
                            }) { Text("Anmelden") }
                            Div({
                                classes(NetzwerkLoginStyles.mobileMenuEntry)
                                if (activeView == NET_VIEW_REGISTER) classes(NetzwerkLoginStyles.mobileMenuEntryActive)
                                onClick {
                                    activeView = NET_VIEW_REGISTER
                                    mobileMenuOpen = false
                                }
                            }) { Text("Registrieren") }
                        }
                    }
                }
            }
            Div({
                classes(NetzwerkLoginStyles.centerBlock)
                if (isMobile) {
                    style {
                        minWidth(0.px)
                        maxWidth(70.percent)
                        overflow("visible")
                    }
                }
            }) {
                A(href = "/", attrs = {
                    onClick {
                        it.preventDefault()
                        window.history.pushState(null, "", "/")
                        activeView = NET_VIEW_NONE
                    }
                }) {
                    Img(src = LogoSettings.desktopRegistrationHeaderLogo) {
                        style { height(38.px) }
                    }
                }
            }
            if (false) Div({ classes(NetzwerkLoginStyles.loginRow) }) {
                Span({
                    classes(NetzwerkLoginStyles.clickableIconText)
                    if (activeView == NET_VIEW_LOGIN) classes(NetzwerkLoginStyles.clickableIconTextActive)
                    onClick {
                        activeView = NET_VIEW_LOGIN
                    }
                }) { Text("Anmelden") }
                Span({ classes(NetzwerkLoginStyles.navigationSeparator) }) { Text("|") }
                Span({
                    classes(NetzwerkLoginStyles.clickableIconText)
                    if (activeView == NET_VIEW_REGISTER) classes(NetzwerkLoginStyles.clickableIconTextActive)
                    onClick {
                        activeView = NET_VIEW_REGISTER
                    }
                }) { Text("Registrieren") }
            }
        }
    }

    Main({ classes(NetzwerkLoginStyles.mainContent, UnifiedAccessStyles.stage) }) {
        when (activeView) {
            NET_VIEW_NONE -> {
                Div({ classes(NetzwerkLoginStyles.gifWrapper) }) {
                    Div({
                        classes(NetzwerkLoginStyles.bgTiltFrame)
                        onMouseMove {
                            it.stopPropagation()
                            updateNetworkTilt(it.currentTarget.asDynamic(), it.clientX.toDouble(), it.clientY.toDouble())
                        }
                        onMouseLeave { resetNetworkTilt(it.currentTarget.asDynamic()) }
                        style {
                            if (isMobile) {
                                width(90.vw)
                                property("max-width", "90vw")
                                property("max-height", "none")
                                property("transform", "none")
                            } else {
                                maxWidth(1000.px)
                                maxHeight(75.vh)
                            }
                        }
                    }) {
                        NetzwerkTeilnehmerUebersicht(
                            compact = false,
                            companies = registeredCompanies,
                            mobileWide = isMobile
                        )
                    }
                }
            }
            NET_VIEW_LOGIN -> NetzwerkLogin(
                onLoginComplete = onSubmit,
                onRegister = {
                    activeView = NET_VIEW_REGISTER
                }
            )
            NET_VIEW_REGISTER -> NetzwerkRegistrierung(
                onLogin = {
                    activeView = NET_VIEW_LOGIN
                },
                onRegistrationComplete = onSubmit
            )
        }
    }
}


private fun roleOptions(): List<All> = listOf(
    All(id = "PRODUZENT", name = "Produzent", file = "images/produzent.png"),
    All(id = "LOGISTIKER", name = "Logistiker", file = "images/logistiker.png"),
    All(id = "HANDEL", name = "Handel", file = "images/handel.png")
)

@Composable
internal fun RegistrationNetworkMap(companies: List<All>, compact: Boolean) {
    NetzwerkTeilnehmerUebersicht(compact = compact, companies = companies)
}

@Composable
fun roleCard(id: String, label: String, img: String, onSelect: (String) -> Unit) {
    var isHovered by remember { mutableStateOf(false) }

    Div({
        classes(NetzwerkLoginStyles.roleCard)
        onMouseEnter { isHovered = true }
        onMouseLeave { isHovered = false }
        onClick { onSelect(id) }
    }) {
        Img(src = img, attrs = {
            classes(NetzwerkLoginStyles.roleImg)
            style {
                property("object-fit", if (isHovered) "cover" else "contain")
                property("transform", if (isHovered) "scale(1)" else "scale(1.20)")
                if (img.endsWith(".svg", ignoreCase = true)) {
                    property("filter", "brightness(0) invert(1)")
                }
            }
        })
        Span({ classes(NetzwerkLoginStyles.roleLabel) }) { Text(label) }
    }
}

@Composable
internal fun RoleIntroSelection(
    selectedRoleId: String,
    onSelect: (String) -> Unit,
    onConfirm: () -> Unit,
    title: String = "Willkommen im lumatica Netzwerk",
    subtitle: String = "Welche Position hast du in der Logistik?"
) {
    val roles = remember { roleOptions() }
    val selectedIndex = roles.indexOfFirst { it.id == selectedRoleId }.takeIf { it >= 0 } ?: 0
    var swipeStartX by remember { mutableStateOf<Double?>(null) }
    var swipeConsumed by remember { mutableStateOf(false) }

    fun selectRelative(direction: Int) {
        val nextIndex = (selectedIndex + direction + roles.size) % roles.size
        onSelect(roles[nextIndex].id)
    }

    fun finishSwipe(clientX: Double) {
        val startX = swipeStartX ?: return
        val deltaX = clientX - startX
        swipeStartX = null
        if (deltaX > 54) {
            swipeConsumed = true
            selectRelative(-1)
        } else if (deltaX < -54) {
            swipeConsumed = true
            selectRelative(1)
        }
    }

    Div({ classes(NetzwerkLoginStyles.roleIntroRoot) }) {
        Div({ classes(NetzwerkLoginStyles.roleIntroHeader) }) {
            H2 { Text(title) }
            P { Text(subtitle) }
        }

        Div({ classes(NetzwerkLoginStyles.roleNav) }) {
            roles.forEach { role ->
                Div({
                    classes(NetzwerkLoginStyles.roleNavItem)
                    if (role.id == selectedRoleId) classes(NetzwerkLoginStyles.roleNavItemActive)
                    onClick { onSelect(role.id) }
                }) {
                    Span { Text(role.name) }
                }
            }
        }

        Div({
            classes(NetzwerkLoginStyles.roleDeck)
            onMouseDown { swipeStartX = it.clientX.toDouble() }
            onMouseUp { finishSwipe(it.clientX.toDouble()) }
            onMouseLeave { swipeStartX = null }
            onTouchStart {
                val touch = it.touches.item(0) ?: return@onTouchStart
                swipeStartX = touch.clientX.toDouble()
            }
            onTouchEnd {
                val touch = it.changedTouches.item(0) ?: return@onTouchEnd
                finishSwipe(touch.clientX.toDouble())
            }
        }) {
            roles.forEachIndexed { index, role ->
                val relative = ((index - selectedIndex + roles.size) % roles.size)
                val isActive = relative == 0
                val transform = when (relative) {
                    0 -> "translate(-50%, -50%) rotate(0deg) scale(1)"
                    1 -> "translate(calc(-50% + 108px), calc(-50% + 26px)) rotate(7deg) scale(0.76)"
                    else -> "translate(calc(-50% - 108px), calc(-50% + 34px)) rotate(-8deg) scale(0.72)"
                }
                Div({
                    classes(NetzwerkLoginStyles.roleDeckCard)
                    if (isActive) classes(NetzwerkLoginStyles.roleDeckCardActive)
                    onClick {
                        if (swipeConsumed) {
                            swipeConsumed = false
                        } else if (isActive) {
                            onConfirm()
                        } else {
                            onSelect(role.id)
                        }
                    }
                    style {
                        property("z-index", if (isActive) "3" else if (relative == 1) "2" else "1")
                        property("transform", transform)
                        property("opacity", if (isActive) "1" else "0.58")
                    }
                }) {
                    Img(src = role.file, attrs = {
                        classes(NetzwerkLoginStyles.roleDeckImage)
                        style {
                            property("object-fit", if (isActive) "cover" else "contain")
                        }
                    })
                }
            }
        }
    }
}

internal object NetzwerkLoginStyles : StyleSheet() {
    val topBarDrop by keyframes {
        from {
            opacity(0)
            property("transform", "translateY(-22px)")
        }
        to {
            opacity(1)
            property("transform", "translateY(0)")
        }
    }
    val bgReveal by keyframes {
        from {
            opacity(0.15)
            property("filter", "blur(18px)")
        }
        to {
            opacity(0.9)
            property("filter", "blur(0)")
        }
    }
    val logoReveal by keyframes {
        from {
            opacity(0)
            property("transform", "translate(-50%, -50%) scale(0.92)")
        }
        to {
            opacity(1)
            property("transform", "translate(-50%, -50%) scale(1)")
        }
    }
    val actionsReveal by keyframes {
        from {
            opacity(0)
            property("transform", "translateY(10px)")
        }
        to {
            opacity(1)
            property("transform", "translateY(0)")
        }
    }
    val roleCardFlyIn by keyframes {
        from {
            opacity(0)
            property("margin-top", "42px")
        }
        to {
            opacity(1)
            property("margin-top", "0")
        }
    }
    val topBar by style {
        position(Position.Fixed); top(0.px); left(0.px); width(100.percent)
        right(0.px); padding(8.px, 28.px); backgroundColor(Color.transparent)
        property("z-index", "100")
        boxSizing("border-box")
        opacity(0)
        property("animation", "${topBarDrop.name} 420ms ease-out 180ms forwards")
    }
    val headerContent by style { display(DisplayStyle.Flex); justifyContent(JustifyContent.FlexEnd); alignItems(AlignItems.Center); width(100.percent); position(Position.Relative); minHeight(42.px) }
    val centerBlock by style {
        position(Position.Absolute); left(50.percent); top(50.percent)
        property("transform", "translate(-50%, -50%)")
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        gap(16.px)
        minWidth(180.px)
        maxWidth(34.percent)
        overflow("hidden")
        padding(0.px)
        opacity(0)
        property("animation", "${logoReveal.name} 520ms ease-out 700ms forwards")
    }
    val centerLogo by style {
        property("object-fit", "contain")
        cursor("pointer")
        flexShrink(0)
    }
    val centerTitle by style {
        color(DashboardTheme.TEXT_LIGHT)
        fontSize(18.px)
        fontWeight("700")
        property("white-space", "nowrap")
        property("overflow", "hidden")
        property("text-overflow", "ellipsis")
        minWidth(0.px)
    }
    val loginRow by style {
        display(DisplayStyle.Flex); gap(16.px); alignItems(AlignItems.Center)
        opacity(0)
        property("animation", "${actionsReveal.name} 420ms ease-out 900ms forwards")
    }
    val clickableIconText by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        cursor("pointer")
        color(Color("rgba(255,255,255,0.72)"))
        fontSize(15.px)
        fontWeight("500")
        padding(6.px, 2.px)
        property("border-bottom", "2px solid transparent")
        property("transition", "color 0.18s ease, border-color 0.18s ease")
        hover { color(Color.white) }
    }
    val clickableIconTextActive by style {
        color(Color.white)
        fontWeight("700")
        property("border-bottom", "2px solid ${DashboardTheme.ACCENT}")
    }
    val mobileNavigation by style {
        position(Position.Absolute)
        left(0.px)
        top(50.percent)
        property("transform", "translateY(-50%)")
        property("z-index", "3")
    }
    val mobileMenuButton by style {
        width(38.px)
        height(38.px)
        padding(0.px)
        border(0.px)
        borderRadius(8.px)
        backgroundColor(Color.transparent)
        color(Color.white)
        fontSize(22.px)
        cursor("pointer")
    }
    val mobileMenuDropdown by style {
        position(Position.Absolute)
        top(46.px)
        left(0.px)
        minWidth(150.px)
        padding(6.px)
        borderRadius(10.px)
        backgroundColor(Color("#111318"))
        property("border", "1px solid rgba(255,255,255,0.14)")
        property("box-shadow", "0 14px 34px rgba(0,0,0,0.38)")
    }
    val mobileMenuEntry by style {
        padding(10.px, 12.px)
        borderRadius(7.px)
        color(Color("rgba(255,255,255,0.78)"))
        fontSize(14.px)
        cursor("pointer")
        hover { color(Color.white) }
    }
    val mobileMenuEntryActive by style {
        color(Color.white)
        property("border-bottom", "2px solid ${DashboardTheme.ACCENT}")
    }
    val mapToLogin by keyframes {
        from {
            opacity(0.92)
            property("transform", "translateX(330px) scale(1.08)")
        }
        to {
            opacity(1)
            property("transform", "translateX(0) scale(1)")
        }
    }
    val formReveal by keyframes {
        from {
            opacity(0)
            property("transform", "translateX(34px)")
        }
        to {
            opacity(1)
            property("transform", "translateX(0)")
        }
    }
    val navigationSeparator by style {
        color(Color("rgba(255,255,255,0.45)"))
        fontSize(18.px)
    }
    val loginMapTransition by style {
        property("transform-origin", "center center")
        property("animation", "${mapToLogin.name} 520ms cubic-bezier(.2,.75,.2,1) both")
    }
    val loginFormReveal by style {
        property("animation", "${formReveal.name} 420ms ease-out 160ms both")
    }
    val svgIconWhite by style { width(24.px); height(24.px) }

    val glowingDivider by style {
        width(3.px)
        minWidth(3.px)
        height(550.px)
        flexShrink(0)
        opacity(1)
        position(Position.Relative)
        property("z-index", "2")
        property("border-radius", "999px")
        property(
            "background",
            "linear-gradient(180deg, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.28) 18%, rgba(255,255,255,0.95) 50%, rgba(255,255,255,0.28) 82%, rgba(255,255,255,0.06) 100%)"
        )
        property("box-shadow", "0 0 24px rgba(255,255,255,0.55), 0 0 10px rgba(255,255,255,0.35)")
    }

    val registerFrame by style {
        padding(40.px); backgroundColor(Color.transparent)
        property("border", "1px solid #2a2d34"); borderRadius(20.px); textAlign("center"); color(Color.white)
        property("backdrop-filter", "blur(15px)"); property("z-index", "200"); boxSizing("border-box")
    }

    val navIcon by style {
        position(Position.Absolute)
        top(50.percent)
        property("transform", "translateY(-50%)")
        width(28.px)
        height(28.px)
        cursor("pointer")
        opacity(0.5)
        hover { opacity(1) }
        media(mediaMaxWidth(768.px)) {
            self style { display(DisplayStyle.None) }
        }
    }
    val navLeft by style { left(25.px) }
    val roleGrid by style { display(DisplayStyle.Flex); gap(24.px); marginTop(24.px) }
    val roleCard by style { flex(1); padding(30.px); borderRadius(15.px); backgroundColor(Color.transparent); property("border", "1px solid #2a2d34"); cursor("pointer"); property("transition", "transform 0.2s ease, border-color 0.2s ease"); hover { property("border-color", "#4a4f59") } }
    val roleImg by style {
        width(100.percent); height(100.px); property("object-position", "center center"); marginBottom(15.px)
        property("transition", "transform 0.28s ease")
    }
    val roleLabel by style { fontSize(18.px); fontWeight("bold") }
    val roleIntroRoot by style {
        width(100.percent)
        height(100.percent)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.FlexStart)
        boxSizing("border-box")
    }
    val roleIntroHeader by style {
        width(100.percent)
        flexShrink(0)
        marginTop((-18).px)
        marginBottom(6.px)
        desc(self, selector("h2")) style {
            marginBottom(8.px)
        }
        desc(self, selector("p")) style {
            margin(0.px)
        }
    }
    val roleNav by style {
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.Center)
        alignItems(AlignItems.Center)
        gap(30.px)
        width(100.percent)
        flexShrink(0)
        marginTop(2.px)
        marginBottom(4.px)
    }
    val roleNavItem by style {
        position(Position.Relative)
        padding(7.px, 2.px, 10.px, 2.px)
        color(DashboardTheme.TEXT_MUTED)
        fontSize(17.px)
        fontWeight("700")
        cursor("pointer")
        property("transition", "color 0.18s ease")
        hover {
            color(DashboardTheme.TEXT_LIGHT)
        }
        self + "::after" style {
            property("content", "\"\"")
            position(Position.Absolute)
            left(0.px)
            right(0.px)
            bottom(0.px)
            height(2.px)
            backgroundColor(Color.transparent)
            property("transition", "background-color 0.18s ease, box-shadow 0.18s ease")
        }
    }
    val roleNavItemActive by style {
        color(DashboardTheme.ACCENT)
        self + "::after" style {
            backgroundColor(DashboardTheme.ACCENT)
            property("box-shadow", "0 0 12px rgba(255,0,0,0.42)")
        }
    }
    val roleDeck by style {
        position(Position.Relative)
        width(100.percent)
        flexGrow(1)
        minHeight(350.px)
        overflow("hidden")
        marginTop(6.px)
        property("touch-action", "pan-y")
    }
    val roleDeckCard by style {
        position(Position.Absolute)
        left(50.percent)
        top(50.percent)
        width(560.px)
        height(318.px)
        overflow("hidden")
        borderRadius(15.px)
        border(1.px, LineStyle.Solid, DashboardTheme.BORDER_LIGHT)
        backgroundColor(Color.transparent)
        cursor("pointer")
        property("box-shadow", "0 20px 58px ${DashboardTheme.SURFACE_SHADOW}")
        property("transition", "transform 0.34s ease, opacity 0.34s ease, border-color 0.22s ease")
        property("animation", "${roleCardFlyIn.name} 520ms ease-out both")
        hover {
            property("border-color", "rgba(255,255,255,0.28)")
        }
    }
    val roleDeckCardActive by style {
        property("border-color", "rgba(255,0,0,0.46)")
        property("box-shadow", "0 20px 58px ${DashboardTheme.SURFACE_SHADOW}, 0 0 28px rgba(255,0,0,0.18)")
    }
    val roleDeckImage by style {
        display(DisplayStyle.Block)
        width(100.percent)
        height(100.percent)
        property("object-position", "center center")
        property("transition", "object-fit 0.34s ease")
    }

    val formGrid by style { width(100.percent); maxWidth(500.px); property("margin-left", "auto"); property("margin-right", "auto"); display(DisplayStyle.Flex); property("flex-direction", "column"); gap(14.px); marginTop(18.px); boxSizing("border-box") }
    val row by style { width(100.percent); display(DisplayStyle.Flex); gap(12.px); boxSizing("border-box") }

    val regInput by style {
        width(100.percent); minWidth(0.px); height(38.px); padding(0.px, 12.px); borderRadius(8.px)
        backgroundColor(Color.transparent); color(Color.white); property("border", "1px solid rgba(255,255,255,0.18)"); property("box-shadow", "0 0 0 1px rgba(255,255,255,0.05), 0 0 18px rgba(255,255,255,0.08)")
        boxSizing("border-box")
        fontSize(13.px)
        focus { property("border-color", "#ffffff"); outline("none") }
    }
    val regInputError    by style { property("border-color", "#ff4d4d") }
    val regInputDisabled by style { opacity(0.5); cursor("not-allowed") }
    val subheading       by style { fontSize(14.px); opacity(0.7) }
    val errorParagraph   by style { color(Color("#ff4d4d")); fontSize(14.px) }
    val successBodyText  by style { fontSize(15.px); lineHeight(1.5.em) }
    val successTextBlock by style { maxWidth(520.px); property("text-align", "center") }

    val bigButton by style {
        width(100.percent); maxWidth(500.px); property("margin-left", "auto"); property("margin-right", "auto"); marginTop(22.px); height(50.px)
        backgroundColor(Color.transparent)
        color(Color.white)
        property("border", "1px solid rgba(255,255,255,0.18)")
        borderRadius(8.px)
        property("box-shadow", "0 0 0 1px rgba(255,255,255,0.05), 0 0 18px rgba(255,255,255,0.08)")
        hover {
            backgroundColor(Color.transparent)
            color(Color.white)
            property("border-color", "rgba(255,255,255,0.18)")
            property("box-shadow", "0 0 0 1px rgba(255,255,255,0.05), 0 0 18px rgba(255,255,255,0.08)")
        }
    }

    val mainContent by style { display(DisplayStyle.Flex); justifyContent(JustifyContent.Center); alignItems(AlignItems.Center); width(100.vw); height(100.vh); backgroundColor(Color.transparent); overflow("hidden"); paddingTop(0.px); boxSizing("border-box"); position(Position.Relative) }
    val gifWrapper by style { width(100.percent); display(DisplayStyle.Flex); justifyContent(JustifyContent.Center); alignItems(AlignItems.Center); position(Position.Relative); property("z-index", "1") }
    val bgTiltFrame by style {
        property("--rx", "0deg")
        property("--ry", "0deg")
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        property("transform", "perspective(1150px) rotateX(var(--rx)) rotateY(var(--ry)) translateY(0) scale(1.018)")
        property("transition", "transform 150ms ease, filter 150ms ease")
        property("will-change", "transform")
        hover {
            property("filter", "drop-shadow(0 32px 82px rgba(0,0,0,0.32)) drop-shadow(0 0 22px rgba(255,0,0,0.08))")
        }
    }
    val bgGif by style {
        display(DisplayStyle.Block)
        width(100.percent)
        property("height", "auto")
        property("object-fit", "contain")
        opacity(0.9)
        property("animation", "${bgReveal.name} 720ms ease-out forwards")
    }

    val fieldErrorText by style { fontSize(11.px); color(Color("#ff4d4d")); opacity(0.9); whiteSpace("nowrap"); property("pointer-events", "none") }
}
